import { render, staticRenderFns } from "./OmniplayEventsAccounting.vue?vue&type=template&id=d8223706"
import script from "./OmniplayEventsAccounting.vue?vue&type=script&lang=js"
export * from "./OmniplayEventsAccounting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports